import PaymentAmountMethod from "./PaymentAmountMethod";

export default PaymentAmountMethod;
